<ex-button type="secondary" variant="raised" size="x-large" icon="arrow-left-fill"
           (click)="onPageClick(currentPage - 1)" [disabled]="currentPage === 1">
  {{'button.prev' | translate}}
</ex-button>
<div class="navigation-items">
  @for (pageIndex of listOfPage; track pageIndex; let i = $index) {
    @if (i === 0) {
      <ex-button [type]="currentPage === pageIndex ? 'primary' : 'secondary'"
                 [variant]="currentPage === pageIndex ? 'raised' : 'ghost'" size="x-large"
                 (click)="onPageClick(pageIndex)">
        {{pageIndex}}
      </ex-button>
    }
    <div class="hidden-indexes"
         *ngIf="currentPage >= maxNbPagesConsecutive && i === 3 && i < nbPages && nbPages > maxNbPagesShow">
      ...
    </div>
    @if ((showWhenInFirstPages(pageIndex) || showWhenInLastPages(pageIndex) || showNextPrevPage(pageIndex))
      && notShowFirstLastPage(i)) {
      <ex-button [type]="currentPage === pageIndex ? 'primary' : 'secondary'"
                 [variant]="currentPage === pageIndex ? 'raised' : 'ghost'" size="x-large"
                 (click)="onPageClick(pageIndex)">
        {{pageIndex}}
      </ex-button>
    }
    <div class="hidden-indexes"
         *ngIf="currentPage <= nbPages - maxNbPagesConsecutive + 1  && i === nbPages - 4 && nbPages > maxNbPagesShow">
      ...
    </div>
    @if (i === nbPages - 1) {
      <ex-button [type]="currentPage === pageIndex ? 'primary' : 'secondary'"
                 [variant]="currentPage === pageIndex ? 'raised' : 'ghost'" size="x-large"
                 (click)="onPageClick(pageIndex)">
        {{pageIndex}}
      </ex-button>
    }
  }
</div>
<ex-button type="secondary" variant="raised" size="x-large" icon="arrow-right-fill" iconPosition="right"
           (click)="onPageClick(currentPage + 1)" [disabled]="currentPage === nbPages">
  {{'button.next' | translate}}
</ex-button>
